import {
  CreatePasskeyMessage,
  CreatePasskeyMessageType,
  CreatePasskeyErrorCode,
} from '../types/createPasskeyMessages';

export const OPENER_ORIGIN_QUERY_PARAM = 'openerOrigin';

export const DEFAULT_TARGET_ORIGIN =
  process.env.NODE_ENV === 'development' ? '*' : 'https://manage.wix.com';

export const getTargetOrigin = (): string => {
  const openerOriginParam = new URLSearchParams(window.location.search).get(
    OPENER_ORIGIN_QUERY_PARAM,
  );
  if (!openerOriginParam) {
    return DEFAULT_TARGET_ORIGIN;
  }
  try {
    const { hostname, origin } = new URL(openerOriginParam);
    const isWixDomain =
      hostname === 'manage.wix.com' || hostname.endsWith('.manage.wix.com');
    return isWixDomain ? origin : DEFAULT_TARGET_ORIGIN;
  } catch {
    return DEFAULT_TARGET_ORIGIN;
  }
};

export const hasOpener = (): boolean => {
  return !!(window.opener && !window.opener.closed);
};

export const getRequestIdFromUrl = (): string | undefined => {
  const params = new URLSearchParams(window.location.search);
  return params.get('requestId') ?? undefined;
};

export const sendMessageToOpener = (
  message: CreatePasskeyMessage,
  targetOrigin?: string,
): boolean => {
  const resolvedTargetOrigin = targetOrigin ?? DEFAULT_TARGET_ORIGIN;
  if (!hasOpener()) {
    console.warn('No opener window available to send message');
    return false;
  }

  const requestId = getRequestIdFromUrl();
  const messageWithRequestId: CreatePasskeyMessage = {
    ...message,
    ...(requestId && { requestId }),
  };

  try {
    window.opener.postMessage(messageWithRequestId, resolvedTargetOrigin);
    return true;
  } catch (error) {
    console.error('Failed to send message to opener:', error);
    return false;
  }
};

export const sendCreatePasskeySuccess = (
  data?: Record<string, unknown>,
  targetOrigin?: string,
): boolean => {
  return sendMessageToOpener(
    { type: CreatePasskeyMessageType.SUCCESS, data },
    targetOrigin,
  );
};

export const sendCreatePasskeyError = (
  errorCode: CreatePasskeyErrorCode,
  targetOrigin?: string,
): boolean => {
  return sendMessageToOpener(
    { type: CreatePasskeyMessageType.ERROR, errorCode },
    targetOrigin,
  );
};

export const sendCreatePasskeyCancelled = (targetOrigin?: string): boolean => {
  return sendMessageToOpener(
    { type: CreatePasskeyMessageType.CANCELLED },
    targetOrigin,
  );
};

export const closePopup = (delayMs: number = 1500): void => {
  setTimeout(() => {
    window.close();
  }, delayMs);
};
